// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1StatesUpdateSchema = z.object({
  state: z.object({
    name: z.coerce.string().max(100).nullish(),
    icon: z.coerce.string().max(100).nullish(),
    color: z.coerce.string().max(10).nullish(),
    billed: z.boolean().nullish(),
    locked: z.boolean().nullish(),
  }),
});
